import type { ReactNode } from "react";

import { cx } from "./cx";
import styles from "./Panel.module.css";

export interface PanelProps {
  title?: ReactNode;
  icon?: ReactNode;
  actions?: ReactNode;
  className?: string;
  children: ReactNode;
}

export function Panel({ title, icon, actions, className, children }: PanelProps): JSX.Element {
  return (
    <section className={cx(styles.panel, className)}>
      {title !== undefined && (
        <header className={styles.header}>
          {icon && (
            <span className={styles.icon} aria-hidden="true">
              {icon}
            </span>
          )}
          <h2 className={styles.title}>{title}</h2>
          {actions && <div className={styles.actions}>{actions}</div>}
        </header>
      )}
      <div className={styles.body}>{children}</div>
    </section>
  );
}
